<app-navbar-style-two></app-navbar-style-two>

<!-- Custom Toast Overlay -->
<div class="custom-toast" [class.show]="toast.show" [class.success]="toast.type === 'success'" [class.error]="toast.type === 'error'" [class.warning]="toast.type === 'warning'">
  <i class="bx" [class.bx-check-circle]="toast.type === 'success'" [class.bx-x-circle]="toast.type === 'error'" [class.bx-info-circle]="toast.type === 'warning'"></i>
  <span class="toast-message">{{toast.message}}</span>
</div>

<div class="premium-profile-wrapper">
  
  <div class="profile-layout-grid">
    
    <!-- Sidebar Navigation -->
    <aside class="profile-sidebar">
      <div class="sidebar-header">
        <h2 class="sidebar-title">My Account</h2>
      </div>
      <ul class="sidebar-menu">
        <li class="menu-item" [class.active]="activeTab === 'profile'" (click)="activeTab = 'profile'">
          <i class="bx bx-user"></i>
          <span>Profile Info</span>
        </li>
        <li class="menu-item" [class.active]="activeTab === 'addresses'" (click)="activeTab = 'addresses'">
          <i class="bx bx-map-pin"></i>
          <span>Address Book</span>
        </li>
        <li class="menu-item" [class.active]="activeTab === 'orders'" (click)="activeTab = 'orders'">
          <i class="bx bx-shopping-bag"></i>
          <span>My Orders</span>
        </li>
        <li class="menu-item" [class.active]="activeTab === 'password'" (click)="activeTab = 'password'">
          <i class="bx bx-shield-quarter"></i>
          <span>Security</span>
        </li>
      </ul>
    </aside>

    <!-- Main Content Area -->
    <main class="profile-content">
      
      <!-- Loading Overlay -->
      <div *ngIf="isLoadingProfile" class="loading-overlay">
        <div class="spinner"></div>
        <p>Loading your details...</p>
      </div>

      <!-- PROFILE TAB -->
      <div *ngIf="activeTab === 'profile' && !isLoadingProfile" class="fade-in">
        <div class="content-header">
          <h2>Profile Information</h2>
          <p>Manage your personal details and contact information.</p>
        </div>

        <div class="content-section">
          <div class="profile-header-premium">
            <div class="avatar-wrapper" (click)="fileInput.click()" title="Click to change profile picture">
              <img *ngIf="user_profile.profile_image" [src]="user_profile.profile_image" class="avatar-img" alt="Profile Picture">
              <div *ngIf="!user_profile.profile_image" class="avatar-text">{{ user_profile.name?.charAt(0) || 'U' }}</div>
              <div class="avatar-badge" [class.uploading]="isUploadingImage">
                <i *ngIf="!isUploadingImage" class="bx bx-camera"></i>
                <span *ngIf="isUploadingImage" class="avatar-spinner"></span>
              </div>
              <input type="file" #fileInput (change)="triggerImageUpload($event)" accept="image/*" style="display: none;">
            </div>
            <div class="user-info-premium">
              <h3>{{ user_profile.name || 'User Profile' }}</h3>
              <span class="badge-yellow">Customer Account</span>
            </div>
          </div>
          
          <div class="profile-details-grid" *ngIf="!editMode">
            <div class="detail-box">
              <label>Email Address</label>
              <p>{{ user_profile.email || 'Not provided' }}</p>
            </div>
            <div class="detail-box">
              <label>Mobile Number</label>
              <p>{{ user_profile.mobile || 'Not provided' }}</p>
            </div>
          </div>

          <div class="profile-actions" *ngIf="!editMode">
            <button class="btn-premium-outline" (click)="toggleEditMode(true)">
              Edit Profile
            </button>
          </div>

          <!-- Edit Form -->
          <div class="edit-form-premium" *ngIf="editMode">
            <form (ngSubmit)="updateProfile()" class="premium-form">
              <div class="form-row">
                <div class="form-group">
                  <label>Full Name</label>
                  <input type="text" [(ngModel)]="profile.name" name="name" class="premium-input" placeholder="Enter Full Name" [class.error-border]="profileErrors.name">
                  <span class="error-msg" *ngIf="profileErrors.name">{{ profileErrors.name }}</span>
                </div>
              </div>
              <div class="form-row grid-2">
                <div class="form-group">
                  <label>Email Address</label>
                  <input type="email" [(ngModel)]="profile.email" name="email" class="premium-input" placeholder="Enter Email Address" [class.error-border]="profileErrors.email">
                  <span class="error-msg" *ngIf="profileErrors.email">{{ profileErrors.email }}</span>
                </div>
                <div class="form-group">
                  <label>Mobile Number</label>
                  <input type="text" [(ngModel)]="profile.mobile" name="mobile" class="premium-input" placeholder="Enter Mobile Number" [class.error-border]="profileErrors.mobile">
                  <span class="error-msg" *ngIf="profileErrors.mobile">{{ profileErrors.mobile }}</span>
                </div>
              </div>
              <div class="form-actions">
                <button type="submit" class="btn-premium-primary" [disabled]="isSavingProfile">
                  <span *ngIf="!isSavingProfile">Save Changes</span>
                  <span *ngIf="isSavingProfile" class="spinner-small"></span>
                </button>
                <button type="button" class="btn-premium-text" (click)="toggleEditMode(false)" [disabled]="isSavingProfile">Cancel</button>
              </div>
            </form>
          </div>
        </div>

        <div class="content-section mt-4" *ngIf="!editMode">
          <div class="content-header-small">
            <h3>Activity Overview</h3>
          </div>
          <div class="stats-grid-premium">
            <div class="stat-box">
              <div class="stat-icon yellow-icon"><i class="bx bx-package"></i></div>
              <div class="stat-info">
                <span class="val">{{ stats.total_orders || 0 }}</span>
                <span class="lbl">Total Orders</span>
              </div>
            </div>
            <div class="stat-box">
              <div class="stat-icon blue-icon"><i class="bx bx-rupee"></i></div>
              <div class="stat-info">
                <span class="val">{{ (stats.total_spent || 0) | number:'1.2-2' }}</span>
                <span class="lbl">Total Spent</span>
              </div>
            </div>
            <div class="stat-box">
              <div class="stat-icon light-icon"><i class="bx bx-calendar"></i></div>
              <div class="stat-info">
                <span class="val">{{ stats.last_order ? (stats.last_order | date:'mediumDate') : 'No orders yet' }}</span>
                <span class="lbl">Last Order Date</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ORDERS TAB -->
      <div *ngIf="activeTab === 'orders' && !isLoadingProfile" class="fade-in">
        <div class="content-header">
          <h2>My Orders</h2>
          <p>Track your recent orders and view purchase history.</p>
        </div>
        <div class="content-section p-0">
          <app-order-summery></app-order-summery>
        </div>
      </div>

      <!-- SECURITY TAB -->
      <div *ngIf="activeTab === 'password' && !isLoadingProfile" class="fade-in">
        <div class="content-header">
          <h2>Account Security</h2>
          <p>Provide your current password and choose a secure new password.</p>
        </div>

        <div class="content-section">
          <form (ngSubmit)="changePassword()" class="premium-form">
            <div class="form-group">
              <label>Current Password</label>
              <input type="password" [(ngModel)]="password.old" name="old" class="premium-input" placeholder="Enter Current Password" [class.error-border]="passwordErrors.old">
              <span class="error-msg" *ngIf="passwordErrors.old">{{ passwordErrors.old }}</span>
            </div>
            <div class="form-row grid-2">
              <div class="form-group">
                <label>New Password</label>
                <input type="password" [(ngModel)]="password.new" name="new" class="premium-input" placeholder="New Password (min. 6 characters)" [class.error-border]="passwordErrors.new">
                <span class="error-msg" *ngIf="passwordErrors.new">{{ passwordErrors.new }}</span>
              </div>
              <div class="form-group">
                <label>Confirm New Password</label>
                <input type="password" [(ngModel)]="confirmNewPassword" name="confirm" class="premium-input" placeholder="Confirm New Password" [class.error-border]="passwordErrors.confirm">
                <span class="error-msg" *ngIf="passwordErrors.confirm">{{ passwordErrors.confirm }}</span>
              </div>
            </div>
            <div class="form-actions mt-3">
              <button type="submit" class="btn-premium-primary" [disabled]="isChangingPassword">
                <span *ngIf="!isChangingPassword">Update Password</span>
                <span *ngIf="isChangingPassword" class="spinner-small"></span>
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- ADDRESSES TAB -->
      <div *ngIf="activeTab === 'addresses' && !isLoadingProfile" class="fade-in">
        <div class="content-header d-flex justify-content-between align-items-center">
          <div>
            <h2>Address Book</h2>
            <p>Manage delivery addresses for your orders.</p>
          </div>
          <button class="btn-premium-primary" (click)="openAddressModal()">
            <i class="bx bx-plus"></i> Add Address
          </button>
        </div>

        <div *ngIf="isLoadingAddresses" class="loading-overlay">
          <div class="spinner"></div>
          <p>Loading addresses...</p>
        </div>

        <div *ngIf="!isLoadingAddresses && addresses.length === 0" class="empty-state-premium">
          <div class="empty-icon-wrap"><i class="bx bx-map"></i></div>
          <h3>No addresses found</h3>
          <p>You haven't added any delivery addresses yet.</p>
          <button class="btn-premium-outline" (click)="openAddressModal()">Add New Address</button>
        </div>

        <div *ngIf="!isLoadingAddresses && addresses.length > 0" class="address-grid-premium">
          <div *ngFor="let addr of addresses" class="address-card-premium" [class.is-default]="addr.is_default">
            <div class="address-card-inner">
              <div class="address-header">
                <span class="tag-type">{{ addr.address_type }}</span>
                <span *ngIf="addr.is_default" class="tag-default"><i class="bx bx-check-circle"></i> Default</span>
              </div>
              <div class="address-body">
                <div class="address-name">{{ addr.address_line1 }}</div>
                <div class="address-sub" *ngIf="addr.address_line2">{{ addr.address_line2 }}</div>
                <div class="address-loc">{{ addr.city }}, {{ addr.state }} - {{ addr.pincode }}</div>
              </div>
              <div class="address-footer">
                <button *ngIf="!addr.is_default" class="btn-link" (click)="setDefaultAddress(addr.id)">Set as Default</button>
                <div class="spacer" *ngIf="addr.is_default"></div>
                <div class="action-icons">
                  <button class="icon-btn edit-icon" (click)="openAddressModal(addr)" title="Edit"><i class="bx bx-edit-alt"></i></button>
                  <button class="icon-btn delete-icon" (click)="deleteAddress(addr.id)" title="Delete"><i class="bx bx-trash"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </main>
  </div>
</div>

<!-- ADDRESS MODAL -->
<div class="modal-backdrop-premium" *ngIf="addressModalOpen">
  <div class="modal-container-premium">
    <div class="modal-header">
      <h2>{{ addressForm.id ? 'Edit Address' : 'Add New Address' }}</h2>
      <button class="close-btn" (click)="closeAddressModal()"><i class="bx bx-x"></i></button>
    </div>
    <div class="modal-body">
      <form (ngSubmit)="saveAddress()" class="premium-form">
        <div class="form-group">
          <label>Address Line 1</label>
          <input type="text" [(ngModel)]="addressForm.address_line1" name="address_line1" class="premium-input" placeholder="House/Flat No., Building, Street" [class.error-border]="addressErrors.address_line1">
          <span class="error-msg" *ngIf="addressErrors.address_line1">{{ addressErrors.address_line1 }}</span>
        </div>
        <div class="form-group">
          <label>Address Line 2 (Optional)</label>
          <input type="text" [(ngModel)]="addressForm.address_line2" name="address_line2" class="premium-input" placeholder="Landmark, Locality, Area">
        </div>
        <div class="form-row grid-2">
          <div class="form-group">
            <label>City</label>
            <input type="text" [(ngModel)]="addressForm.city" name="city" class="premium-input" placeholder="City" [class.error-border]="addressErrors.city">
            <span class="error-msg" *ngIf="addressErrors.city">{{ addressErrors.city }}</span>
          </div>
          <div class="form-group">
            <label>State</label>
            <input type="text" [(ngModel)]="addressForm.state" name="state" class="premium-input" placeholder="State" [class.error-border]="addressErrors.state">
            <span class="error-msg" *ngIf="addressErrors.state">{{ addressErrors.state }}</span>
          </div>
        </div>
        <div class="form-row grid-2">
          <div class="form-group">
            <label>Pincode</label>
            <input type="text" [(ngModel)]="addressForm.pincode" name="pincode" class="premium-input" placeholder="Pincode/ZIP code" [class.error-border]="addressErrors.pincode">
            <span class="error-msg" *ngIf="addressErrors.pincode">{{ addressErrors.pincode }}</span>
          </div>
          <div class="form-group">
            <label>Address Type</label>
            <select [(ngModel)]="addressForm.address_type" name="address_type" class="premium-select">
              <option value="Home">Home</option>
              <option value="Work">Work/Office</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>
        <div class="form-group mt-2">
          <label class="premium-checkbox">
            <input type="checkbox" [(ngModel)]="addressForm.is_default" name="is_default" [disabled]="addressForm.id && addressForm.is_default">
            <span class="checkmark"></span>
            <span class="label-text">Set as default delivery address</span>
          </label>
        </div>
        <div class="form-actions mt-4">
          <button type="submit" class="btn-premium-primary" [disabled]="isSavingAddress">
            <span *ngIf="!isSavingAddress">Save Address</span>
            <span *ngIf="isSavingAddress" class="spinner-small"></span>
          </button>
          <button type="button" class="btn-premium-text" (click)="closeAddressModal()" [disabled]="isSavingAddress">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</div>